<div
	class="skeleton-product-card-container hmf-display-flex hmf-flex-column"
	[class]="{
		'hmf-justify-content-between': !compareCheckboxEnabled(),
		'hmf-justify-content-evenly': compareCheckboxEnabled()
	}"
	[style.--desktop-height.px]="desktopHeight()">
	<div [class]="{'hmf-flex-grow hmf-flex-m-grow-none': compareCheckboxEnabled()}">
		<div class="hmf-m-xs skeleton-grey-loading-box big"></div>
		<div class="hmf-m-xs skeleton-grey-loading-box small"></div>
	</div>
	<div
		class="hmf-m-xs skeleton-grey-loading-box medium"
		[class]="{ 'hmf-display-none hmf-display-m-block': compareCheckboxEnabled() }"
	></div>

	@if (compareCheckboxEnabled()) {
		<hmf-checkbox
			class="compare-checkbox"
			[label]="'Compare'"
			[disabled]="true"
		></hmf-checkbox>
	}
</div>
